'use client';

import { useEffect, useRef, useState } from 'react';
import NextImage from 'next/image';
import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';

type TopImageProps = {
    defaultImage: string;
    smallImage: string;
};
export default function TopImage({ defaultImage, smallImage }: TopImageProps) {
    const [defaultImageLoaded, setDefaultImageLoaded] = useState(false);
    const [smallImageLoaded, setSmallImageLoaded] = useState(false);
    const defaultImageRef = useRef<HTMLImageElement | null>(null);
    const smallImageRef = useRef<HTMLImageElement | null>(null);

    useEffect(() => {
        setDefaultImageLoaded(false);
    }, [defaultImage]);

    useEffect(() => {
        setSmallImageLoaded(false);
    }, [smallImage]);

    useEffect(() => {
        const image = defaultImageRef.current;
        if (!image) {
            return;
        }

        if (image.complete && image.naturalWidth > 0) {
            setDefaultImageLoaded(true);
        }
    }, [defaultImage]);

    useEffect(() => {
        const image = smallImageRef.current;
        if (!image) {
            return;
        }

        if (image.complete && image.naturalWidth > 0) {
            setSmallImageLoaded(true);
        }
    }, [smallImage]);

    return (
        <div className="tablet:max-w-[560px] desktop:max-w-[1024px] relative z-10 w-[72vw] max-w-[350px]">
            <div className="tablet:block desktop:block relative hidden">
                {!defaultImageLoaded && (
                    <div className="absolute inset-0 z-10 overflow-hidden rounded-[16px] bg-[#F1F1F1] before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1.6s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/70 before:to-transparent" />
                )}
                <NextImage
                    ref={defaultImageRef}
                    alt={'top image'}
                    title={'top image'}
                    width={1024}
                    height={356}
                    src={getStaticAssetUrl(defaultImage)}
                    draggable={false}
                    onLoad={() => setDefaultImageLoaded(true)}
                    onError={() => setDefaultImageLoaded(true)}
                    className={
                        defaultImageLoaded
                            ? 'pointer-events-none h-auto w-full'
                            : 'pointer-events-none h-auto w-full opacity-0'
                    }
                />
            </div>
            <div className="tablet:hidden desktop:hidden relative">
                {!smallImageLoaded && (
                    <div className="absolute inset-0 z-10 overflow-hidden rounded-[16px] bg-[#F1F1F1] before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1.6s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/70 before:to-transparent" />
                )}
                <NextImage
                    ref={smallImageRef}
                    alt={'top image'}
                    title={'top image'}
                    width={350}
                    height={192}
                    src={getStaticAssetUrl(smallImage)}
                    draggable={false}
                    onLoad={() => setSmallImageLoaded(true)}
                    onError={() => setSmallImageLoaded(true)}
                    className={
                        smallImageLoaded
                            ? 'pointer-events-none h-auto w-full'
                            : 'pointer-events-none h-auto w-full opacity-0'
                    }
                />
            </div>
        </div>
    );
}
